import { Model } from "@/models/base/model";

export class UserAuthorFollow extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // フォロー登録取得
  async getUserAuthorFollows(): Promise<any> {
    this.url = `/cms/api/users/author-follows/list`;
    return await super.fetch();
  }

  // フォロー登録更新
  async updateUserAuthorFollows(posterId: number): Promise<any> {
    this.url = "/cms/api/users/author-follows/update";
    return await this.save({ posterId }, "POST");
  }
}
